import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from './api.service';
import { ModelService } from './model/model.service';
import {AuthGuard} from "./_guards/auth.guard";
import {DatePipe} from "./pipes/date.pipe";
import {AuthenticationService} from "./authentication.service";
import {SafePipe} from "./pipes/safe.pipe";
import {ProductService} from "./product.service";
import {ContactService} from "./contact.service";

const MODULES = [
  // Do NOT include UniversalModule, HttpModule, or JsonpModule here
  CommonModule,
  RouterModule,
  FormsModule,
  ReactiveFormsModule
];

const PIPES = [
  // put pipes here
  DatePipe,
  SafePipe
];

const COMPONENTS = [
  // put shared components here
];

const PROVIDERS = [
  ModelService,
  ApiService,
  AuthGuard,
  AuthenticationService,
  ProductService,
  ContactService
];

@NgModule({
  imports: [
    ...MODULES
  ],
  declarations: [
    ...PIPES,
    ...COMPONENTS
  ],
  exports: [
    ...MODULES,
    ...PIPES,
    ...COMPONENTS
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        ...PROVIDERS
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/shared.module.ts